module.exports = __webpack_public_path__ + "static/3-493ffdff433395ee825c08551e1712b2.png";